import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import { isGeDomain } from 'utils/helpers/domains/getDomain'

import azTranslations from 'assets/i18n/az/translation.json'
import enTranslations from 'assets/i18n/en/translation.json'
import kaTranslations from 'assets/i18n/ka/translation.json'
import ruTranslations from 'assets/i18n/ru/translation.json'

const savedLanguage = sessionStorage.getItem('i18nextLng') || (isGeDomain() ? 'ka' : 'ru')

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'ru',
    lng: savedLanguage,
    debug: import.meta.env.VITE_NODE_ENV !== 'prod',
    supportedLngs: ['ru', 'ka', 'az'],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    returnEmptyString: false,
    resources: {
      en: {
        translation: enTranslations,
      },
      ru: {
        translation: ruTranslations,
      },
      ka: {
        translation: kaTranslations,
      },
      az: {
        translation: azTranslations,
      },
    },
  })

export default i18n
